import {createElement, subscribeEvent} from 'methods/utils';
import Modal from 'developer_components/newModal';
import YandexMap from 'components/kurort-map-modal-yandex';
import Checkbox from 'components/kurort-map-modal-checkbox';
import ProgressBar from 'components/kurort-map-modal-progress';
import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.css';
import metrikaCollector, {collectYandexReachGoal} from 'components/metrika';

/**
 * Компонент который управляет картой и поиском по нему
 */
function KurortMapModal($container, options = {}) {
    if (!$container) {
        return;
    }

    const $element = Modal.createFromHTML(
        `<div class="Map__filter">
            <div class="Map__filter-wrapper">
                <div class="Map__filter-container js-mapFilterContainer">

                    <!-- Блок фильтров --><!-- /Блок фильтров -->

                    <!-- Контейнер карты и списка отелей -->
                    <div class="Map__filter-hotels-and-map-container js-mapHotelsAndMapContainer">

                        <!-- /Блок отелей --><!-- /Блок отелей -->

                        <!-- Контейнер с картой -->
                        <div class="Map__filter-map-container">

                            <!-- Верхние кнопки -->
                            <div class="Map__filter-map-header js-mapFilterMapHeader">
                                <div class="js-mapFilterMapHeaderPlace" data-for="hotels-open"></div>
                                <div class="js-mapFilterMapHeaderPlace" data-for="search-on-move"></div>
                                <div class="js-mapFilterMapHeaderPlace" data-for="map-close">
                                    <button type="button" title="Закрыть карту" class="Map__filter-map-header-item Map__filter-map-header-button Map__filter-map-header-button--close js-mapModalClose">
                                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M19.0303 6.53033C19.3232 6.23744 19.3232 5.76256 19.0303 5.46967C18.7374 5.17678 18.2626 5.17678 17.9697 5.46967L12.5 10.9393L7.03033 5.46967C6.73744 5.17678 6.26256 5.17678 5.96967 5.46967C5.67678 5.76256 5.67678 6.23744 5.96967 6.53033L11.4393 12L5.96967 17.4697C5.67678 17.7626 5.67678 18.2374 5.96967 18.5303C6.26256 18.8232 6.73744 18.8232 7.03033 18.5303L12.5 13.0607L17.9697 18.5303C18.2626 18.8232 18.7374 18.8232 19.0303 18.5303C19.3232 18.2374 19.3232 17.7626 19.0303 17.4697L13.5607 12L19.0303 6.53033Z" fill="currentColor"/>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                            <!-- /Верхние кнопки -->

                            <!-- Карта -->
                            <div class="Map__filter-map js-kurortHotelsMap"></div>
                            <!-- /Карта -->
                        </div>
                        <!-- /Контейнер с картой -->

                        <div class="Map__filter-map--preloader js-mapPreloader is-active">
                            <div class="Map__filter-map--preloader-logo"></div>
                            <div class="Map__filter-map--preloader-text">Ищем лучшие предложения :)</div>
                        </div>

                    </div>
                    <!-- /Контейнер карты и списка отелей -->
                </div>
            </div>
        </div>`,
        {
            className: 'Kurort-map-modal',
        }
    );

    this.$container = $container;
    this.$container.appendChild($element);

    // наследуемся
    Modal.call(this, $element, options);

    this._simpleBar = {};

    this.$close              = this.$element.querySelector('.js-mapModalClose');
    this.$map                = this.$element.querySelector('.js-kurortHotelsMap');
    this.$mapFilterContainer = this.$element.querySelector('.js-mapFilterContainer');

    this.$mapFilterMapHeaderPlace = [...this.$element.querySelectorAll('.js-mapFilterMapHeaderPlace[data-for]')].reduce((acc, $el) => {
        acc[$el.dataset.for] = $el;
        return acc;
    }, {});

    if (~this.options.components.indexOf('filters')) {
        this.$mapFilterContainer.insertAdjacentHTML('afterbegin',
            `<!-- Блок фильтров -->
            <div class="Map__filter-filters-wrapper js-mapFilterFiltersWrapper">
                <div class="Map__filter-filters-container js-mapFilterFiltersContainer">
                    <div class="Map__filter-filters js-mapFilters">

                        <!-- Блок статичных фильтров -->
                        <!-- <div class="Map__filter-block js-mapStaticFilter" data-filter="hotel-type">
                            <div class="Map__filter-block_header">
                                <span class="Map__filter-block--title">Типы объектов</span>
                                <span class="Map__filter-block--close"></span>
                            </div>
                            <div class="Map__filter-block_body">
                                <div class="Kurort-sidebar__inner">
                                    <div class="Kurort-sidebar__check js-checkboxWrapper">
                                        <label class="Kurort-sidebar__check-inner js-checkboxItemContainer" data-type="hotel">
                                            <div class="Kurort-sidebar__custom-checkbox js-checkboxItem is-active">
                                                <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.6898 0.275994C16.0897 0.656955 16.105 1.28994 15.724 1.68979L6.1966 11.6898C6.00787 11.8879 5.74621 12 5.4726 12C5.19898 12 4.93732 11.8879 4.74859 11.6898L0.275994 6.99534C-0.104967 6.59549 -0.0896484 5.96251 0.31021 5.58154C0.710069 5.20058 1.34305 5.2159 1.72401 5.61576L5.4726 9.55029L14.276 0.31021C14.657 -0.0896484 15.2899 -0.104967 15.6898 0.275994Z" fill="white"></path>
                                                </svg>
                                            </div>
                                            <input name="place_type" type="checkbox" class="Kurort-sidebar__checkbox js-checkboxField" value="Отели" checked>
                                            <span>Отели</span>
                                        </label>
                                    </div>
                                    <div class="Kurort-sidebar__check js-checkboxWrapper">
                                        <label class="Kurort-sidebar__check-inner js-checkboxItemContainer" data-type="beach">
                                            <div class="Kurort-sidebar__custom-checkbox js-checkboxItem">
                                                <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.6898 0.275994C16.0897 0.656955 16.105 1.28994 15.724 1.68979L6.1966 11.6898C6.00787 11.8879 5.74621 12 5.4726 12C5.19898 12 4.93732 11.8879 4.74859 11.6898L0.275994 6.99534C-0.104967 6.59549 -0.0896484 5.96251 0.31021 5.58154C0.710069 5.20058 1.34305 5.2159 1.72401 5.61576L5.4726 9.55029L14.276 0.31021C14.657 -0.0896484 15.2899 -0.104967 15.6898 0.275994Z" fill="white"></path>
                                                </svg>
                                            </div>
                                            <input name="place_type" type="checkbox" class="Kurort-sidebar__checkbox js-checkboxField" value="Пляжи">
                                            <span>Пляжи</span>
                                        </label>
                                    </div>
                                    <div class="Kurort-sidebar__check js-checkboxWrapper">
                                        <label class="Kurort-sidebar__check-inner js-checkboxItemContainer" data-type="place">
                                            <div class="Kurort-sidebar__custom-checkbox js-checkboxItem">
                                                <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.6898 0.275994C16.0897 0.656955 16.105 1.28994 15.724 1.68979L6.1966 11.6898C6.00787 11.8879 5.74621 12 5.4726 12C5.19898 12 4.93732 11.8879 4.74859 11.6898L0.275994 6.99534C-0.104967 6.59549 -0.0896484 5.96251 0.31021 5.58154C0.710069 5.20058 1.34305 5.2159 1.72401 5.61576L5.4726 9.55029L14.276 0.31021C14.657 -0.0896484 15.2899 -0.104967 15.6898 0.275994Z" fill="white"></path>
                                                </svg>
                                            </div>
                                            <input name="place_type" type="checkbox" class="Kurort-sidebar__checkbox js-checkboxField" value="Достопримечательности">
                                            <span>Достопримечательности</span>
                                        </label>
                                    </div>
                                    <div class="Kurort-sidebar__check js-checkboxWrapper">
                                        <label class="Kurort-sidebar__check-inner js-checkboxItemContainer" data-type="airport">
                                            <div class="Kurort-sidebar__custom-checkbox js-checkboxItem">
                                                <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.6898 0.275994C16.0897 0.656955 16.105 1.28994 15.724 1.68979L6.1966 11.6898C6.00787 11.8879 5.74621 12 5.4726 12C5.19898 12 4.93732 11.8879 4.74859 11.6898L0.275994 6.99534C-0.104967 6.59549 -0.0896484 5.96251 0.31021 5.58154C0.710069 5.20058 1.34305 5.2159 1.72401 5.61576L5.4726 9.55029L14.276 0.31021C14.657 -0.0896484 15.2899 -0.104967 15.6898 0.275994Z" fill="white"></path>
                                                </svg>
                                            </div>
                                            <input name="place_type" type="checkbox" class="Kurort-sidebar__checkbox js-checkboxField" value="Аэропорты">
                                            <span>Аэропорты</span>
                                        </label>
                                    </div>
                                    <div class="Kurort-sidebar__check js-checkboxWrapper">
                                        <label class="Kurort-sidebar__check-inner js-checkboxItemContainer" data-type="train_station">
                                            <div class="Kurort-sidebar__custom-checkbox js-checkboxItem">
                                                <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.6898 0.275994C16.0897 0.656955 16.105 1.28994 15.724 1.68979L6.1966 11.6898C6.00787 11.8879 5.74621 12 5.4726 12C5.19898 12 4.93732 11.8879 4.74859 11.6898L0.275994 6.99534C-0.104967 6.59549 -0.0896484 5.96251 0.31021 5.58154C0.710069 5.20058 1.34305 5.2159 1.72401 5.61576L5.4726 9.55029L14.276 0.31021C14.657 -0.0896484 15.2899 -0.104967 15.6898 0.275994Z" fill="white"></path>
                                                </svg>
                                            </div>
                                            <input name="place_type" type="checkbox" class="Kurort-sidebar__checkbox js-checkboxField" value="ЖД вокзалы">
                                            <span>Ж/д вокзалы</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <!-- /Блок статичных фильтров -->
                    </div>
                </div>
            </div>
            <!-- /Блок фильтров -->`
        );

        this.$mapFilterFiltersWrapper   = this.$element.querySelector('.js-mapFilterFiltersWrapper');
        this.$mapFilterFiltersContainer = this.$element.querySelector('.js-mapFilterFiltersContainer');
        this.$mapFilters                = this.$element.querySelector('.js-mapFilters');

        this.$mapStaticFilter = [...this.$element.querySelectorAll('.js-mapStaticFilter[data-filter]')].reduce((acc, $el) => {
            acc[$el.dataset.filter] = $el;
            return acc;
        }, {});

        // прокрутка для фильтров
        this._simpleBar.filters = new SimpleBar(this.$mapFilterFiltersContainer, {
            autoHide: false,
        });

        // клик по пунктам в фильтре "Типы объектов"
        if (this.$mapStaticFilter['hotel-type']) {
            const $checkboxes = this.$mapStaticFilter['hotel-type'].querySelectorAll('.js-checkboxItemContainer');
            $checkboxes.forEach($checkbox => {
                new Checkbox($checkbox, {
                    on: {
                        checked: (checked) => {
                            this.map.setCollectionVisibility($checkbox.dataset.type, checked);
                        },
                    },
                });
            });
        }
    }

    this.$mapHotelsAndMapContainer = this.$element.querySelector('.js-mapHotelsAndMapContainer');
    this.$mapPreloader             = this.$element.querySelector('.js-mapPreloader');
    this.$mapFilterMapHeader       = this.$element.querySelector('.js-mapFilterMapHeader');

    if (~this.options.components.indexOf('search-on-move')) {
        this.$mapFilterMapHeaderPlace['search-on-move'].insertAdjacentHTML('afterbegin',
            `<div class="Map__filter-map-header-item js-mapSearchOnMove">
                <div class="Kurort-sidebar__check js-checkboxWrapper">
                    <label class="checkbox">
                        <input type="checkbox" name="place_type" value="1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <rect class="checkbox__background" width="24" height="24" rx="8"/>
                            <rect class="checkbox__border" x="0.75" y="0.75" width="22.5" height="22.5" rx="7.25" stroke="#D4D2D8" stroke-width="1.5"/>
                            <path class="checkbox__mark" fill-rule="evenodd" clip-rule="evenodd" d="M19.6898 6.27599C20.0897 6.65696 20.105 7.28994 19.724 7.68979L10.1966 17.6898C10.0079 17.8879 9.74621 18 9.4726 18C9.19898 18 8.93732 17.8879 8.74859 17.6898L4.27599 12.9953C3.89503 12.5955 3.91035 11.9625 4.31021 11.5815C4.71007 11.2006 5.34305 11.2159 5.72401 11.6158L9.4726 15.5503L18.276 6.31021C18.657 5.91035 19.2899 5.89503 19.6898 6.27599Z" fill="white"/>
                        </svg>
                        <span class="checkbox__title">Поиск при перемещении карты</span>
                    </label>
                </div>
            </div>`
        );

        this.$mapSearchOnMove         = this.$element.querySelector('.js-mapSearchOnMove');
        this.$mapSearchOnMoveCheckbox = this.$mapSearchOnMove.querySelector('input[type="checkbox"]');

        this.setSearchOnMove(this.options.searchOnMove);
        this.$mapSearchOnMoveCheckbox.addEventListener('change', (e) => {
            this._disablePreloaderOnce = true;
            this.emit('search-on-move:checked', e.target.checked);
            this.emit('move');
        });
    }

    if (~this.options.components.indexOf('hotels')) {
        this.$mapHotelsAndMapContainer.insertAdjacentHTML('afterbegin',
            `<!-- /Блок отелей -->
            <div class="Map__filter-hotels-wrapper js-mapHotelsWrapper">
                <div class="Map__filter-hotels-container js-mapHotelsContainer"></div>
            </div>
            <!-- /Блок отелей -->`
        );

        this.$mapFilterMapHeaderPlace['hotels-open'].insertAdjacentHTML('afterbegin',
            `<button type="button" title="Показать список объектов" class="Map__filter-map-header-item Map__filter-map-header-button Map__filter-map-header-button--hotels js-mapHotelsOpen">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.2929 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071Z" fill="#6A6D81"/>
                </svg>
            </button>`
        );

        this.$mapHotelsWrapper   = this.$element.querySelector('.js-mapHotelsWrapper');
        this.$mapHotelsContainer = this.$element.querySelector('.js-mapHotelsContainer');
        this.$mapHotelsOpen      = this.$element.querySelector('.js-mapHotelsOpen');

        // прокрутка для отелей
        this._simpleBar.hotels = new SimpleBar(this.$mapHotelsWrapper, {
            autoHide: false,
        });

        this.$mapHotelsContainer.addEventListener('mouseover', this._onMapHotelsContainerMouseEvent.bind(this, true));
        this.$mapHotelsContainer.addEventListener('mouseout', this._onMapHotelsContainerMouseEvent.bind(this, false));

        this.toggleHotels(this.options.showHotelList);
    }

    this.$pageHotelListWrapper = document.querySelector('.js-hotelListWraper');

    this.header             = this.options.header;
    this.kurortFilter       = this.options.kurortFilter;
    this._restoreElementMap = {};

    if (this.header) {
        // влиять на шапку только если карта открыта
        this.header.on('open', this._applyHeaderStates.bind(this));
        this.header.on('close', this._applyHeaderStates.bind(this));
        this.header.on('update', this._applyHeaderStates.bind(this));
    }

    // модалка готова
    this.$element.classList.add('is-initialized');

    this.map = new YandexMap(this.$map, {
        latitude: this.options.latitude,
        longitude: this.options.longitude,
        zoom: this.options.zoom,
        init: false,
        clusteredHotels: true,
        on: {
            'boundschange': (bounds, zoom) => {
                // ресайз элемента не влияет на boundschange
                if (this._mapLastWidth != this.$map.offsetWidth || this._mapLastHeight != this.$map.offsetHeight) {
                    this._mapLastWidth = this.$map.offsetWidth;
                    this._mapLastHeight = this.$map.offsetHeight;
                    return;
                }

                clearTimeout(this._mapBoundsChangeTimeout);

                if (!this.getSearchOnMove()) {
                    return;
                }

                this._mapBoundsChangeTimeout = setTimeout(() => {
                    this._disablePreloaderOnce = true;
                    this.emit('move');
                }, 100);
            },
            'hotel:balloonopen': (hotel) => {
                this.setHotelActiveState(hotel.id, true);
            },
            'hotel:balloonclose': (hotel) => {
                this.setHotelActiveState(hotel.id, false);
            },
            'hotel:mouseenter': (hotel) => {
                this.setHotelHoverState(hotel.id, true);
            },
            'hotel:mouseleave': (hotel) => {
                this.setHotelHoverState(hotel.id, false);
            },
        },
    });

    this.$close && this.$close.addEventListener('click', this.close.bind(this));
    this.$mapHotelsOpen && this.$mapHotelsOpen.addEventListener('click', this._onMapHotelsClickEvent.bind(this));

    subscribeEvent('updateMapBefore', this._onUpdateMapBeforeEvent.bind(this));
    subscribeEvent('updateMap', this._onUpdateMapEvent.bind(this));

    this.on('open', () => {
        if (typeof yaCounter46243086 !== "undefined") {
            yaCounter46243086.reachGoal('open_map');
            collectYandexReachGoal(metrikaCollector, 'open_map');
        }
    });

    this.on('search-on-move:checked', (checked) => {
        if (checked) {
            if (typeof yaCounter46243086 !== "undefined") {
                yaCounter46243086.reachGoal('map_moving');
                collectYandexReachGoal(metrikaCollector, 'map_moving');
            }
        }
    });
}

// цепочка прототипов
KurortMapModal.prototype = Object.create(Modal.prototype)
Object.defineProperty(KurortMapModal.prototype, 'constructor', {
    value: KurortMapModal,
    enumerable: false,
    writable: true,
});

KurortMapModal.prototype.setOptions = function(options) {
    Modal.prototype.setOptions.call(this, Object.assign({
        components: [
            // 'hotels',
            // 'filters',
            // 'search-on-move',
        ],
        searchOnMove: false,
        showHotelList: false,
    }, this.getElementDataset(this.$container) || {}, options));
}

KurortMapModal.prototype.opened = function() {
    return this.$element.classList.contains('is-active');
}

KurortMapModal.prototype.open = function() {
    const openPromise = Modal.prototype.open.call(this);

    // перенос отелей в модалку
    if (this.$mapHotelsContainer && this.$pageHotelListWrapper) {
        this._transferElement('hotels', this.$pageHotelListWrapper, this.$mapHotelsContainer);
    }

    if (this.kurortFilter && this.$mapFilters) {
        this.kurortFilter.renderCustomFilters(this.$mapFilters);
        this.setFiltersVisibility(true);
    }
    window.kurortMapModal = this;

    if (this.header) {
        this.header.pushStates();
        this._applyHeaderStates();
    }

    // показываем прелоадер
    this.preloaders(true);

    return openPromise.then(() => this.map.init());
}

KurortMapModal.prototype.close = function() {
    if (this.kurortFilter) {
        this.kurortFilter.renderDefaultFilters();
    }
    delete window.kurortMapModal;

    if (this.header) {
        this.header.popStates();
    }

    this._restoreElement('hotels');
    this._restoreElement('hotels-not-found');

    Modal.prototype.close.call(this);
}

KurortMapModal.prototype.openHotels = function() {
    this.toggleHotels(true);
}

KurortMapModal.prototype.closeHotels = function() {
    this.toggleHotels(false);
}

KurortMapModal.prototype.toggleHotels = function(state) {
    const active = typeof state == 'undefined' ? this.$mapHotelsWrapper.classList.contains('is-active') : !state;
    this.$mapHotelsWrapper.classList.toggle('is-active', !active);
    this.$mapHotelsOpen.classList.toggle('is-active', !active);
    this.$mapHotelsOpen.title = `${active ? 'Показать' : 'Скрыть'} список объектов`;
}

KurortMapModal.prototype.setFiltersVisibility = function(state) {
    if (this.$mapFilterFiltersWrapper) {
        this.$mapFilterFiltersWrapper.classList.toggle('is-active', state);
    }
}

KurortMapModal.prototype.setHotelHoverState = function(id, state) {
    const $container = this._getHotelListContainer();
    if (!$container) {
        return;
    }

    const $hotel = $container.querySelector(`.js-hotelItem[data-id="${id}"]`);
    if ($hotel) {
        $hotel.classList.toggle('is-hover', state);
    }

    this.map.setHotelPlacemarkHoverState(id, state);
}

KurortMapModal.prototype.setHotelActiveState = function(id, state) {
    const $container = this._getHotelListContainer();
    if (!$container) {
        return;
    }

    const $hotel = $container.querySelector(`.js-hotelItem[data-id="${id}"]`);
    if ($hotel) {
        $hotel.classList.toggle('is-active', state);
    }

    this.map.setHotelPlacemarkActiveState(id, state);
}

KurortMapModal.prototype.preloaders = function(state, show_more = false) {
    if (!this.opened()) {
        return;
    }

    if (!state) {
        this.preloaderMain(state);
        this.preloaderMore(state);
        return;
    }

    if (show_more) {
        this.preloaderMore(state);
        return;
    }

    this.preloaderMain(state);
}

KurortMapModal.prototype.preloaderMain = function(state) {
    this.$mapPreloader.classList.toggle('is-active', state);
}

KurortMapModal.prototype.preloaderMore = function(state) {
    const $container = this._getHotelListContainer();
    if (!$container) {
        return;
    }

    $container.style.opacity = state ? 0.3 : '';
    $container.style.pointerEvents = state ? 'none' : '';
}

/**
 * Вызов обработчика после инициализации карт
 * @param  {Function} cb callback
 * @return {Promise}
 */
KurortMapModal.prototype.whenMapInitialized = function(cb) {
    return this.map.whenInitialized(cb);
}

KurortMapModal.prototype._onUpdateMapBeforeEvent = function(request) {
    this._lastRequest = request;
    clearTimeout(this._mapBoundsChangeTimeout);

    // прогресс
    this._getProgressBar(true).setProgress(0.3);

    if (!this._disablePreloaderOnce) {
        // показываем прелоадер
        this.preloaders(true, request.show_more);
    }

    this._disablePreloaderOnce = false;
}

KurortMapModal.prototype._onUpdateMapEvent = function(response, request) {
    this._lastResponse = response;

    // прогресс
    this._getProgressBar().setProgress(0.5);

    if (!this.map.initialized()) {
        this._getProgressBar().setProgress(1);
        this.preloaders(false, request.show_more);
        return;
    }

    // метки загружаются все, поэтому на "показать ещё" можно не реагировать
    if (request.show_more) {
        this._getProgressBar().setProgress(1);
        this.preloaders(false, request.show_more);
        return;
    }

    this.setPlacemarks(response.data.placemarks)
        .then(() => {
            this._getProgressBar().setProgress(0.7);

            // компонент filters
            if (this.$mapStaticFilter && this.$mapStaticFilter['hotel-type']) {
                // обновление видимости статичных фильтров
                const $checkboxes = [...this.$mapStaticFilter['hotel-type'].querySelectorAll('.js-checkboxItemContainer')];
                const showCount = $checkboxes.reduce((acc, $checkbox) => {
                    const name = $checkbox.dataset.type;
                    const placemarks = this.map.getCollectionPlacemarks(name);
                    const $input = $checkbox.querySelector('input[type="checkbox"]');
                    const show = placemarks.length > 0;

                    $checkbox.parentNode.style.display = show ? '' : 'none';

                    this.map.whenInitialized(() => {
                        this.map.setCollectionVisibility(name, $input.checked);
                    });

                    return acc + show;
                }, 0);

                this.$mapStaticFilter['hotel-type'].style.display = showCount ? '' : 'none';
            }
        })
        .catch(console.error)
        .finally(() => {
            this._getProgressBar().setProgress(1);
            this.preloaders(false);
        });
}

KurortMapModal.prototype.setPlacemarks = function(placemarks) {
    return this.map.setPlacemarks(placemarks);
}

/**
 * Поиск при перемещении
 * @return {Boolean}
 */
KurortMapModal.prototype.getSearchOnMove = function() {
    if (!this.$mapSearchOnMoveCheckbox) {
        return false;
    }

    return this.$mapSearchOnMoveCheckbox.checked;
}

/**
 * Поиск при перемещении
 * @return {Boolean}
 */
KurortMapModal.prototype.setSearchOnMove = function(state) {
    if (!this.$mapSearchOnMoveCheckbox) {
        return false;
    }

    return this.$mapSearchOnMoveCheckbox.checked = state;
}

/**
 * Центровать карту
 * @return {Boolean}
 */
KurortMapModal.prototype.mapCenterByCollection = function(name) {
    return this.map.centerByCollection(name);
}

KurortMapModal.prototype._onMapHotelsClickEvent = function() {
    this.toggleHotels();
}

KurortMapModal.prototype._onMapHotelsContainerMouseEvent = function(state, e) {
    if (!e.target) {
        return;
    }

    const $hotel = e.target.closest('.js-hotelItem[data-id]');
    if (!$hotel) {
        return;
    }

    this.setHotelHoverState($hotel.dataset.id, state);
}

KurortMapModal.prototype._getProgressBar = function(fresh = false) {
    if (fresh && this._progressBar) {
        this._progressBar.remove();
    }

    if (fresh || !this._progressBar || this._progressBar.done) {
        this._progressBar = new ProgressBar(this.$mapHotelsAndMapContainer);
    }

    return this._progressBar;
}

KurortMapModal.prototype._getHotelListContainer = function() {
    return this.$pageHotelListWrapper;
}

KurortMapModal.prototype._transferElement = function(name, $element, $to) {
    const $placeholder = createElement(
        `<div style="display: none;"></div>`
    );

    $element.insertAdjacentElement('beforebegin', $placeholder);
    $to.appendChild($element);

    this._restoreElementMap[name] = function() {
        $placeholder.insertAdjacentElement('afterend', $element);
        $placeholder.parentElement.removeChild($placeholder);
    }

    return this._restoreElementMap[name];
}

KurortMapModal.prototype._restoreElement = function(name) {
    if (!this._restoreElementMap[name]) {
        return;
    }

    this._restoreElementMap[name]();
    delete this._restoreElementMap[name];
}

KurortMapModal.prototype._applyHeaderStates = function() {
    if (this.opened()) {
        this.header.setFixed(true);
        this.header.setSearchPlateVisibility(!this.header.opened());
        this.header.toFront(true);
    }
}

export default KurortMapModal;
